module.exports = __webpack_public_path__ + "img/Big_Arts_Yokel@1x.7f0c4979.webp";